import { Injectable } from '@angular/core';
import { CanActivate, NavigationExtras, Router } from '@angular/router';
import { TenantConstant } from '@app-constants/tenant.constant';
@Injectable({
  providedIn: 'root',
})
export class SubscriptionGuard implements CanActivate {
  tenant : any = TenantConstant.tenant;
  constructor(public router: Router) {}

  canActivate(): boolean {
    return this.tenant != 'srichaitanya';
  }
}
